/* "Raspberry" by tPenguinLTG
 * https://www.deviantart.com/tpenguinltg/art/Raspberry-539289720
 */

export default {
  name: 'raspberry',
  anchor: 'rgb(10, 36, 106)',
  anchorVisited: 'rgb(10, 36, 106)',
  borderDark: 'rgb(92, 101, 107)',
  borderDarkest: 'rgb(64, 64, 64)',
  borderLight: 'rgb(142, 151, 157)',
  borderLightest: 'rgb(200, 204, 206)',
  canvas: 'rgb(255, 255, 255)',
  canvasText: 'rgb(0, 0, 0)',
  canvasTextDisabled: 'rgb(92, 101, 107)',
  canvasTextDisabledShadow: 'rgb(200, 204, 206)',
  canvasTextInvert: 'rgb(255, 255, 255)',
  checkmark: 'rgb(0, 0, 0)',
  checkmarkDisabled: 'rgb(92, 101, 107)',
  flatDark: 'rgb(92, 101, 107)',
  flatLight: 'rgb(142, 151, 157)',
  focusSecondary: 'rgb(200, 204, 206)',
  headerBackground: 'rgb(153, 0, 51))',
  headerNotActiveBackground: 'rgb(92, 101, 107)',
  headerNotActiveText: 'rgb(212, 208, 200)',
  headerText: 'rgb(255, 255, 255)',
  hoverBackground: 'rgb(10, 36, 106)',
  material: 'rgb(142, 151, 157)',
  materialDark: 'rgb(92, 101, 107)',
  materialText: 'rgb(0, 0, 0)',
  materialTextDisabled: 'rgb(92, 101, 107)',
  materialTextDisabledShadow: 'rgb(200, 204, 206)',
  materialTextInvert: 'rgb(255, 255, 255)',
  progress: 'rgb(10, 36, 106)',
  tooltip: 'rgb(255, 255, 225)',
};
